/**
 * Attempts to invoke a function and returns its result if no errors occur.
 * Unlike, lodash's _.attempt, this does not return the caught error.
 *
 * @param {Function} func The function to invoke
 * @returns The return value of the function
 */
export default function attempt(func) {
  try {
    return func();
  } catch {
    return undefined;
  }
}
